import { useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import ProjectPicker from './ProjectPicker';

const ProjectPickerModal = ({ initialNextPage, initialProjects, onClose, onConfirm, open, selectedProject }) => {
  const [draftProject, setDraftProject] = useState(selectedProject);

  if (!open) return null;

  return createPortal(
    <dialog className="modal" open>
      <div className="modal-box max-w-xl">
        <h3 className="text-lg font-bold">Choose project</h3>
        <div className="mt-4">
          <ProjectPicker
            initialNextPage={initialNextPage}
            initialProjects={initialProjects}
            onSelect={setDraftProject}
            selectedProjectId={draftProject?.value}
          />
        </div>
        <div className="modal-action">
          <button type="button" className="btn btn-sm btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            disabled={!draftProject?.value}
            onClick={() => onConfirm(draftProject)}
          >
            Select
          </button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button type="button" onClick={onClose}>
          close
        </button>
      </form>
    </dialog>,
    document.body,
  );
};

ProjectPickerModal.propTypes = {
  initialNextPage: PropTypes.string,
  initialProjects: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedProject: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

export default ProjectPickerModal;
